// extracted by mini-css-extract-plugin
export default {"root":"EpisodeDetail_root__p4CI-","titleSkeleton":"EpisodeDetail_titleSkeleton__hw5Ux"};